import { Logo as MedlyLogo } from '@medly-components/core';
import type { FC } from 'react';

import BlackLogo from './BlackLogo';
import { NameLogoStyled, ShortLogoStyled } from './Logo.Styled';
import { LogoProps } from './types';

export const Logo: FC<LogoProps> = ({ showName, blackLogo }) => {
    if (blackLogo) {
        return <BlackLogo />;
    }
    return <MedlyLogo showName={showName} logo={<ShortLogoStyled />} name={<NameLogoStyled />} />;
};
